
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"active-highlight",attrs:{"d":"M21.472 0H2.528A2.531 2.531 0 000 2.528v18.944A2.531 2.531 0 002.528 24h18.944A2.531 2.531 0 0024 21.472V2.528A2.535 2.535 0 0021.472 0zm1.327 21.472c0 .73-.597 1.327-1.327 1.327H2.528c-.73 0-1.328-.597-1.328-1.327V2.528c0-.73.598-1.328 1.328-1.328h18.944c.73 0 1.327.598 1.327 1.328v18.944z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M16.532 11.402h-3.934V7.468a.602.602 0 10-1.206 0v3.934H7.458a.601.601 0 100 1.2h3.934v3.935a.602.602 0 101.206 0v-3.934h3.934c.334 0 .603-.27.603-.603a.598.598 0 00-.603-.598z","fill":"#00003C"}})])
          )
        }
      }
    